import { api } from './authService';

const eventService = {
  getAllEvents: () => {
    return api.get('/events');
  },

  getEvents: () => {
    return api.get('/events');
  },

  getEventsAdmin: () => {
    return api.get('/events/admin/all');
  },

  getEvent: (id) => {
    return api.get(`/events/${id}`);
  },

  createEvent: (eventData) => {
    return api.post('/events', eventData);
  },

  updateEvent: (id, eventData) => {
    return api.put(`/events/${id}`, eventData);
  },

  deleteEvent: (id) => {
    return api.delete(`/events/${id}`);
  },

  bookEvent: (eventId, dateId) => {
    return api.post(`/events/${eventId}/book`, { dateId });
  },

  cancelBooking: (eventId, dateId) => {
    return api.delete(`/events/${eventId}/book`, { data: { dateId } });
  },

  getUserBookings: () => {
    return api.get('/events/user/bookings');
  },

  getStats: () => {
    return api.get('/events/stats');
  }
};

export default eventService;
export { eventService };
